<template>
  <div class="col-12 h-100 text-white">
    <sidebar-item
      icon="cubes"
      :text="t('object_nav')" 
      @click="$emit('input', 'objects')"
    ></sidebar-item>
    <sidebar-item
      v-show="with_versions"
      icon="code-branch"
			:text="t('version_sidebar')"     
      @click="$emit('input', 'versions')"
    ></sidebar-item>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem.vue';
import translations from '../i18n/translations.js';
//text="Objects"
//text="Versions" 
export default {
	name: "NinjaSidebar",
	components: {
		SidebarItem
	},
	props: {
		value: {
			type: String,
			default: 'objects'
		},
		with_versions: {
			type: Boolean,
			default: false
		},
		lang: { // 👈 从父组件接收语言
      type: String,
      default: 'zh'
    }
	},
	data: function () {

		return {
			translations,
		};

	},
  methods: {
    t(key) {
      return this.translations[this.lang][key] || key;
    }
  }
};
</script>
